import React, { useEffect, useState } from "react"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import { useDispatch, useSelector } from "react-redux"
import {
  activitySendToErp,
  getDetailFertilization,
  updateAreaActivityImage
} from "../../../../../redux/actions/AreaAction.jsx"
import { Button, Card } from "react-bootstrap"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { DetailText, RowText, Status } from "../../../../../component/index.jsx"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import {
  checkBadgePaymentStatus,
  convertDotToComma,
  convertM2ToHectareParseFloat,
  stringFormatting,
  toKilogram,
  toMeter,
  toRupiah,
  toThousandConvert
} from "../../../../helpers/TextHelper.js"
import { AREA, GENERAL } from "../../../../../constants/InitTypeConstants.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { ActivityDetailHeader } from "../../../../../component/molecule/ActivityDetailHeader/ActivityDetailHeader.jsx"
import { useTranslation } from "react-i18next"
import swal from "sweetalert"
import { PopupQuestion } from "../../../../../component/atoms/Popup/index.jsx"
import {
  ACTIVITY_METHODE_ENUM,
  ACTIVITY_STATUS_ENUM,
  DATE_TYPE_ENUM,
  OWNER_TYPE_ENUM,
  UNIT_STRING
} from "../../../../../constants/StringConstant.js"
import { ErpNumber } from "../../../../../component/atoms/ErpNumber/ErpNumber.jsx"
import BootstrapTable from "react-bootstrap-table-next"
import { getHSTUnit } from "../../../../helpers/StringCollection.js"

export const FertilizationDetail = ({
  match: {
    params: { status, id, activity_id }
  }
}) => {
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { MasterData, General, Area } = useSelector((state) => state)
  const [detail, setDetail] = useState({})
  const [idDocument, setIdDocument] = useState(null)
  const [showModalDialog, setShowModalDialog] = useState(false)
  const isWaiting = detail?.activity_status_enum === ACTIVITY_STATUS_ENUM.WAITING
  const isNotConfirmed = detail?.activity_detail_response?.is_confirm_by_admin === false
  const hasMaxxiTaniOwner = [
    ...(detail?.detail_product_service?.fertilizers ?? []),
    ...(detail?.detail_product_service?.pesticides ?? [])
  ].some((item) => item?.owner_enum === OWNER_TYPE_ENUM.MAXXI_TANI)

  useEffect(() => {
    dispatch(getDetailFertilization(activity_id))
  }, [])

  useEffect(() => {
    if (Area.data) {
      setDetail(Area.data)
    }
  }, [Area])

  useEffect(() => {
    if (detail) {
      if (isWaiting && (hasMaxxiTaniOwner || isNotConfirmed)) {
        subHeader.setButton(btnApprove)
      } else {
        subHeader.setButton(null)
      }

      subHeader.setBreadcrumbs([
        {
          pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status),
          title: t("label_area_name")
        },
        {
          pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status),
          title: t("label_registered")
        },
        {
          pathname: RoutesConstants.AREA.DETAIL_AREA(status, id),
          title: detail?.area_information?.area_name
        },
        {
          title: "Pemupukan ke " + detail?.activity_detail_response?.seq
        }
      ])
    }
  }, [detail])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete) {
      if (General.actionInitType === GENERAL.UPLOAD) {
        const data = {
          id: detail?.activity_detail_response?.image_and_id_activity[idDocument]?.id,
          url: MasterData.urlResponseUpload
        }

        dispatch(updateAreaActivityImage(data))
      } else if (General.actionInitType === AREA.UPDATE_ACTIVITY_IMAGE) {
        dispatch(getDetailFertilization(activity_id))
      } else if (
        General.loading === false &&
        General.actionInitType === AREA.APPROVE_ACTIVITY_TO_ERP
      ) {
        setShowModalDialog(false)
        swal({
          icon: ILLUSTRATION_CONSTANTS.SUCCESS_FORM,
          text: t("messages_response_activity_approve_to_erp_success")
        })
        dispatch(getDetailFertilization(activity_id))
      }
    }
  }, [General])

  const labelActivity = (
    <ActivityDetailHeader
      title={`AKTIVITAS PEMUPUKAN KE-${detail?.activity_detail_response?.seq}`}
      icon={ICON_CONSTANTS.ACTIVITY_ICONS.FERTILIZATION}
      rightContent={
        ((isWaiting && (hasMaxxiTaniOwner || isNotConfirmed)) ||
          (detail?.activity_detail_response?.is_confirm_by_admin === true &&
            detail?.activity_status_enum === ACTIVITY_STATUS_ENUM.APPROVED)) && (
          <Status
            text={detail?.activity_status_string}
            variant={
              detail?.activity_status_enum === ACTIVITY_STATUS_ENUM.APPROVED
                ? "completed"
                : "warning"
            }
          />
        )
      }
      bottomContent={
        <ErpNumber
          noFaktur={detail?.no_faktur}
          noOrderSj={detail?.no_order_sj}
          noOrderSpk={detail?.no_order_spk}
          noOrderErp={detail?.no_order_erp}
          status={detail?.activity_type_enum}
        />
      }
    />
  )

  const btnApprove = (
    <Button className={"btn btn-primary"} onClick={() => setShowModalDialog(true)}>
      {t("button_send_to_finance")}
    </Button>
  )

  const bills = (
    <Card className={"mb-4"}>
      <CardBody>
        <div className={"d-flex justify-content-between align-items-center"}>
          <h4 className={"mb-6 text-uppercase"}>{t("details_bill")}</h4>
          {checkBadgePaymentStatus(detail?.billing_detail?.payment_status, "mb-6")}
        </div>
        <Card bg={"secondary"}>
          <CardBody className={"px-8 py-6"}>
            <RowModule customColumnCss={"col-md-6"} withoutSeparator={true}>
              <RowText
                label={t("total_bills")}
                value={toRupiah(detail?.billing_detail?.total_bill)}
              />
              <RowText
                label={t("remaining_bill")}
                value={toRupiah(detail?.billing_detail?.remaining_bill)}
              />
              <RowText
                label={t("already_paid")}
                value={toRupiah(detail?.billing_detail?.paid_amount)}
              />
              <RowText
                label={t("paid_date")}
                value={stringFormatting(
                  timeStampToDate(
                    detail?.billing_detail?.paid_date,
                    DATE_TYPE_ENUM.ISO_DATE_STRAP
                  )
                )}
              />
            </RowModule>
          </CardBody>
        </Card>
      </CardBody>
    </Card>
  )

  const areaInformation = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-6 text-uppercase"}>INFORMASI LAHAN</h4>
        <RowModule customColumnCss={"col-md-6 mb-2"}>
          <RowModule>
            <RowText
              label={t("label_area_name")}
              value={stringFormatting(detail?.area_information?.area_name)}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_manual_area_size")}
              value={
                detail?.area_information?.area_land_manual
                  ? toMeter(detail?.area_information?.area_land_manual)
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText
              hasIcon={detail?.area_information?.has_kur}
              icon={detail?.area_information?.bank_image}
              label={t("label_farmer")}
              value={
                detail?.area_information?.farmer_name
                  ? `${detail?.area_information?.farmer_name} (${detail?.area_information?.farmer_code})`
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_polygon_area_size")}
              value={
                detail?.area_information?.area_land_polygon
                  ? toMeter(detail?.area_information?.area_land_polygon)
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_mitra")}
              value={
                detail?.area_information?.mitra_name
                  ? `${detail?.area_information?.mitra_name} (${detail?.area_information?.mitra_code})`
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_plant_type")}
              value={stringFormatting(detail?.area_information?.plant_type_name)}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_area_location")}
              value={stringFormatting(detail?.area_information?.full_address)}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_plant_varieties")}
              value={stringFormatting(detail?.area_information?.variety_name)}
            />
          </RowModule>
        </RowModule>
      </CardBody>
    </Card>
  )

  const detailActivitas = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-6 mt-6 text-uppercase"}>{t("label_activity_detail")}</h4>
        <RowModule customColumnCss={"col-md-6 mb-2"}>
          <RowModule>
            <RowText
              label={t("label_submitted_by")}
              value={stringFormatting(detail?.activity_detail_response?.submitted_by)}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_hst")}
              value={getHSTUnit(detail?.activity_detail_response?.hst)}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("report_submitted_date")}
              value={
                detail?.activity_detail_response?.submitted_date
                  ? timeStampToDate(
                      detail?.activity_detail_response?.submitted_date,
                      DATE_TYPE_ENUM.ISO_DATETIME_STRAP
                    )
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("fertilization_method")}
              value={stringFormatting(detail?.fertilization_method_string)}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("seq_fertilization")}
              value={stringFormatting(detail.activity_detail_response?.seq)}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_alsintan_land_area_worked")}
              value={
                detail?.activity_detail_response?.worked_area
                  ? toMeter(detail?.activity_detail_response?.worked_area)
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_activity_date")}
              value={
                detail?.activity_detail_response?.activity_date
                  ? timeStampToDate(
                      detail?.activity_detail_response?.activity_date,
                      DATE_TYPE_ENUM.ISO_DATE_STRAP
                    )
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_liquid_use")}
              value={stringFormatting(
                detail?.activity_detail_response?.liquid_used_value,
                detail?.activity_detail_response?.liquid_used_unit
              )}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("team_drone_name")}
              value={`${stringFormatting(detail?.activity_detail_response?.submitted_by_team)} ${
                detail.activity_detail_response?.drone_team_member?.length
                  ? ` (${detail.activity_detail_response?.drone_team_member.join(", ")})`
                  : ""
              }`}
            />
          </RowModule>
        </RowModule>
        <div className={"my-10"}>
          <h4 className={"mb-6"}>CATATAN</h4>
          <div className={"row mb-4"}>
            {(detail?.activity_detail_response?.image_and_id_activity ?? []).map((item, index) => {
              return (
                <div className={"col-md-3"} key={index}>
                  <DetailText
                    type="image"
                    value={item.url}
                    indexKey={index}
                    menu={AREA.ACTIVITY_FERTILIZATION}
                    setIdDocument={setIdDocument}
                  />
                </div>
              )
            })}
          </div>
          <div className="font-weight-bold text-dark-50 font-size-sm">
            {stringFormatting(detail?.activity_detail_response?.activity_note)}
          </div>
        </div>
      </CardBody>
    </Card>
  )

  const getColumnsArea = (isPesticide = false) => [
    {
      dataField: "name",
      text: isPesticide ? t("pesticide_name") : t("fertilizer_name"),
      headerClasses: "bg-gray",
      headerStyle: { width: "30%" },
      style: { width: "30%" }
    },
    {
      dataField: "is_subsidy",
      text: !isPesticide ? t("fertilizer_source") : "",
      headerClasses: "bg-gray",
      headerStyle: { width: "14%" },
      style: { width: "14%" }
    },
    {
      dataField: "unit_price",
      text: t("unit_price"),
      headerClasses: "bg-gray",
      headerStyle: { width: "14%" },
      style: { width: "14%" }
    },
    {
      dataField: "ownership",
      text: t("label_ownership"),
      headerClasses: "bg-gray",
      headerStyle: { width: "14%" },
      style: { width: "14%" }
    },
    {
      dataField: "usage_value",
      text: t("usage"),
      headerClasses: "bg-gray",
      headerStyle: { width: "14%" },
      style: { width: "14%" }
    },
    {
      dataField: "total_price",
      text: t("label_price"),
      headerClasses: "bg-gray",
      headerStyle: { width: "14%" },
      style: { width: "14%" }
    }
  ]

  const dataFertilizer = (detail?.detail_product_service?.fertilizers ?? []).map((item) => {
    const price = toRupiah(item.price)
    return {
      name: stringFormatting(item.name),
      is_subsidy: stringFormatting(item.is_subsidy ? t("subsidized") : t("non_subsidized")),
      unit_price: item.unit ? `${price} /${item.unit}` : price,
      ownership: stringFormatting(item.owner_string),
      usage_value: stringFormatting(toThousandConvert(item.usage), item.unit),
      total_price:
        item.owner_enum !== OWNER_TYPE_ENUM.FARMER ? (
          toRupiah(item.total_price)
        ) : (
          <div className={"text-muted"}>{t("no_charge")}</div>
        )
    }
  })

  const dataPesticide = (detail?.detail_product_service?.pesticides ?? []).map((item) => {
    const price = toRupiah(item.price)
    return {
      name: stringFormatting(item.name),
      unit_price: item.unit ? `${price} /${item.unit}` : price,
      ownership: stringFormatting(item.owner_string),
      usage_value: stringFormatting(toThousandConvert(item.usage), item.unit),
      total_price: toRupiah(item.total_price)
    }
  })

  const detailProductService = (
    <Card>
      <CardBody>
        <h4 className={"mb-6 mt-6 text-uppercase"}>{t("detail_product_service")}</h4>
        {dataFertilizer.length > 0 && (
          <div className={"border rounded table-small-padding mb-10"}>
            <BootstrapTable
              condensed
              bordered={false}
              columns={getColumnsArea(false)}
              keyField={"name"}
              data={dataFertilizer ?? []}
            />
          </div>
        )}
        {dataPesticide?.length > 0 && (
          <>
            <div className={"border rounded table-small-padding mb-10"}>
              <BootstrapTable
                condensed
                bordered={false}
                columns={getColumnsArea(true)}
                keyField={"name"}
                data={dataPesticide ?? []}
              />
            </div>
          </>
        )}
        <RowModule>
          <div className="row">
            <div className="col-md-7">
              <h5 className="mb-3">{t("label_note_description")} :</h5>
              <div className="font-weight-bold text-dark-50 font-size-sm ml-2">
                <ol className="pl-3 mb-0">
                  <li key={1} className={"text-muted mb-1"}>
                    {t("land_service_fee_partnership")}
                  </li>
                  <li key={2} className={"text-muted mb-1"}>
                    {t("fertilizer_not_charge_except_owned_by_maxxi")}
                  </li>
                  <li key={3} className={"text-muted mb-1"}>
                    {t("maximal_fertilizer_loaded_fee")}
                  </li>
                </ol>
              </div>
            </div>
            <div className="col-md-5">
              <div className={"p-3 rounded px-8 py-6"} style={{ background: "#F8F8F8" }}>
                <div>
                  <div className={"d-flex justify-content-between mb-2"}>
                    <div className={"d-flex"}>
                      <div className={"mr-1"}>
                        {t("service_total")} <sup>1</sup>
                      </div>
                      <div>
                        (
                        {convertDotToComma(
                          convertM2ToHectareParseFloat(
                            detail?.activity_detail_response?.worked_area,
                            3
                          )
                        )}{" "}
                        {UNIT_STRING.HA})
                      </div>
                    </div>
                    <div className={"text-right"}>
                      {detail?.activity_detail_response?.activity_methode_enum ===
                      ACTIVITY_METHODE_ENUM.MANUAL ? (
                        <div className={"text-muted"}>{t("no_charge")}</div>
                      ) : (
                        toRupiah(detail?.detail_product_service?.summary?.total_service)
                      )}
                    </div>
                  </div>

                  <div className={"d-flex justify-content-between mb-2"}>
                    <div className={"d-flex"}>
                      <div className={"mr-1"}>
                        {t("fertilizer_sub_total")} <sup>2</sup>
                      </div>
                      <div>
                        ({stringFormatting(detail?.detail_product_service?.fertilizers.length)})
                      </div>
                    </div>
                    <div className={"text-right"}>
                      {detail?.detail_product_service?.summary?.subtotal_fertilizer > 0 ? (
                        toRupiah(detail?.detail_product_service?.summary?.subtotal_fertilizer)
                      ) : (
                        <div className={"text-muted"}>{t("no_charge")}</div>
                      )}
                    </div>
                  </div>

                  <div className={"d-flex justify-content-between mb-2"}>
                    <div className={"d-flex"}>
                      <div className={"mr-1"}>{t("pesticide_sub_total")}</div>
                      <div>
                        ({stringFormatting(detail?.detail_product_service?.pesticides.length)})
                      </div>
                    </div>
                    <div className={"text-right"}>
                      {toRupiah(detail?.detail_product_service?.summary?.subtotal_pesticide)}
                    </div>
                  </div>

                  <div className={"d-flex justify-content-between mb-2"}>
                    <div className={"d-flex"}>
                      <div className={"mr-1"}>
                        {t("excess_weight_product")} <sup>3</sup>
                      </div>
                      <div>({toKilogram(detail?.detail_product_service?.summary?.overweight)})</div>
                    </div>
                    <div className={"text-right"}>
                      {detail?.detail_product_service?.summary?.price_overweight ? (
                        toRupiah(detail?.detail_product_service?.summary?.price_overweight)
                      ) : (
                        <div className={"text-muted"}>{t("no_charge")}</div>
                      )}
                    </div>
                  </div>

                  <div style={{ borderTop: "1px dotted #ccc", margin: "12px 0" }} />

                  <div className={"d-flex justify-content-between font-weight-bold"}>
                    <div>
                      {t("total")}
                      <small className={"text-muted"}> +{t("tax_11_percent")}</small>
                    </div>
                    <div>{toRupiah(detail?.detail_product_service?.summary?.total_price)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </RowModule>
      </CardBody>
    </Card>
  )

  return (
    <>
      <PopupQuestion
        onCancel={() => setShowModalDialog(false)}
        textCancel={t("button_cancel")}
        textOk={t("button_continue")}
        title={t("messages_title_activity_send_to_erp")}
        onOk={() => {
          dispatch(activitySendToErp(activity_id, {}))
          setShowModalDialog(false)
        }}
        show={showModalDialog}
        bodyCustom={
          <RowModule>
            <p className={"swal-text p-4"}>
              {t("messages_confirmation_activity_approve_to_erp_confirmation")}
            </p>
          </RowModule>
        }
      />
      {labelActivity}
      {detail?.billing_detail?.payment_status && bills}
      {areaInformation}
      {detailActivitas}
      {detailProductService}
    </>
  )
}
